function JaneStreetRobotBaseBall() {
    return (<div>
        My solution to the Jane Street Robot BaseBall puzzle.
    </div>);
}

export default JaneStreetRobotBaseBall;